
import Vue from 'vue';
import Pagination from '@/components/Pagination/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import { getUserGroup } from '@/utils';
import {
  getAllTerritories,
  GetAllTerritoriesParams,
} from '@/services/territory/get-all-territories';
import Table from '@/components/TableAdapter/index.vue';
import { Wrapper, ContentList } from './styles';

export default Vue.extend({
  components: {
    Wrapper,
    ContentList,
    Pagination,
    ResultMessage,
    Table,
  },
  data() {
    return {
      territories: [] as any,
      userGroup: '',
      loading: false,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      headers: [
        { key: 'nameFarm', value: 'Produtor', isOrder: true },
        { key: 'name', value: 'Território' },
        { key: 'city', value: 'Cidade', isOrder: true },
        { key: 'status', value: 'Status', tag: true },
      ] as any[],
    };
  },
  computed: {
    getTerritories(): any[] {
      return this.territories.map((territory: any) => ({
        ...territory,
        nameFarm: territory.agents[0].name,
        status: territory.vlStatus === 'PROVISORIO' ? 'Ativo' : 'Inativo',
      }));
    },
  },
  methods: {
    moreDetails(row) {
      this.$router.push({ name: 'Prod DetailsAdmin', params: { id: row.$original.id, name: row.$original.name } });
    },
    async getTerritoriesRequest(page = 1, pageSize = 10) {
      this.loading = true;
      this.userGroup = `${getUserGroup()}`;

      const params: GetAllTerritoriesParams = {
        page,
        pageSize,
      };
      const response = await getAllTerritories(params);

      this.territories = response?.results || [];
      this.pagination.total = response?.rowCount || 0;
      this.loading = false;
    },
    setOffset(page: number) {
      this.pagination.page = page;
      this.getTerritoriesRequest(page);
    },
  },
  created() {
    this.getTerritoriesRequest();
  },
});
